export const urlConfig = {
  development: {
    plapi: "http://php-api.test1.zhaojiafang.com/api",
    extapi: "http://extapi.test1.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test1.zhaojiafang.com", // sku详情前缀
    main: "http://www.test1.zhaojiafang.com", // 主站前缀
    newMain: "http://seller.test1.zhaojiafang.com",
    search: "http://search.test1.zhaojiafang.com", // 搜索前缀
    member: "http://member.test1.zhaojiafang.com", // 用户前缀
    mainApi: "http://nodejs-api.test1.zhaojiafang.com/v1", //主站请求前缀
    login: "http://login.test1.zhaojiafang.com", // 登录前缀
    user: "http://sc.test1.zhaojiafang.com",
    erp: "http://daifa.test1.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com",
    pages: "http://pages.test1.zhaojiafang.com"
  },
  production: {
    plapi: "http://api-pl.zhaojiafang.com/api",
    extapi: "http://extapi.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.zhaojiafang.com",
    main: "http://www.zhaojiafang.com",
    newMain: "http://seller.zhaojiafang.com",
    search: "http://search.zhaojiafang.com",
    member: "http://member.zhaojiafang.com",
    mainApi: "http://api.zhaojiafang.com/v1",
    login: "http://login.zhaojiafang.com",
    user: "http://sc.zhaojiafang.com",
    erp: "http://daifa.zhaojiafang.com",
    qiniu: "http://qiniu.zhaojiafang.com",
    pages: "http://pages.zhaojiafang.com"
  },
  test1: {
    plapi: "http://php-api.test1.zhaojiafang.com/api",
    extapi: "http://extapi.test1.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test1.zhaojiafang.com",
    main: "http://www.test1.zhaojiafang.com",
    newMain: "http://seller.test1.zhaojiafang.com",
    search: "http://search.test1.zhaojiafang.com",
    member: "http://member.test1.zhaojiafang.com",
    mainApi: "http://nodejs-api.test1.zhaojiafang.com/v1",
    login: "http://login.test1.zhaojiafang.com",
    user: "http://sc.test1.zhaojiafang.com",
    erp: "http://daifa.test1.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com",
    pages: "http://pages.test1.zhaojiafang.com"
  },
  test2: {
    plapi: "http://php-api.test2.zhaojiafang.com/api",
    extapi: "http://extapi.test2.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test2.zhaojiafang.com",
    main: "http://www.test2.zhaojiafang.com",
    search: "http://search.test2.zhaojiafang.com",
    member: "http://member.test2.zhaojiafang.com",
    mainApi: "http://nodejs-api.test2.zhaojiafang.com/v1",
    login: "http://login.test2.zhaojiafang.com",
    user: "http://sc.test2.zhaojiafang.com",
    erp: "http://daifa.test2.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com"
  },
  test3: {
    plapi: "http://php-api.test3.zhaojiafang.com/api",
    extapi: "http://extapi.test3.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test3.zhaojiafang.com",
    main: "http://www.test3.zhaojiafang.com",
    search: "http://search.test3.zhaojiafang.com",
    member: "http://member.test3.zhaojiafang.com",
    mainApi: "http://nodejs-api.test3.zhaojiafang.com/v1",
    login: "http://login.test3.zhaojiafang.com",
    user: "http://sc.test3.zhaojiafang.com",
    erp: "http://daifa.test3.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com"
  },
  stage: {
    plapi: "http://php-api.stage.zhaojiafang.com/api",
    extapi: "http://extapi.staging.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.staging.zhaojiafang.com",
    main: "http://www.staging.zhaojiafang.com",
    search: "http://search.staging.zhaojiafang.com",
    member: "http://member.staging.zhaojiafang.com",
    mainApi: "http://nodejs-api.stage.zhaojiafang.com/v1",
    login: "http://login.staging.zhaojiafang.com",
    user: "http://sc.stage.zhaojiafang.com",
    erp: "http://daifa.stage.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com"
  }
};

export const APP_ENV = process.env.APP_ENV;

export const CurrentEnvPrefix = urlConfig[APP_ENV];



//////////////////
// WEBPACK FOOTER
// ./config/urlprefix.js
// module id = Kf48
// module chunks = 46